// GAVION A12: admin notice (dashboard and /courriels) for sends on hold or to check. Hidden when none.
import { TriangleAlert } from "lucide-react";
import { useTranslate } from "ra-core";
import { Link } from "react-router";
import { Alert, AlertDescription, AlertTitle } from "@/components/ui/alert";
import { useEmailAttention } from "./useEmailAttention";

const BRAND =
  "border-[#F77119]/40 bg-[#F77119]/10 text-foreground [&>svg]:text-[#F77119]";
const K = "gavion.email.attention";

export const EMAIL_ATTENTION_PATH = "/courriels/a-verifier";

export const EmailAttentionBanner = () => {
  const t = useTranslate();
  const { held, review } = useEmailAttention();
  if (held === 0 && review === 0) return null;
  return (
    <Alert className={BRAND}>
      <TriangleAlert />
      <AlertTitle className="flex flex-wrap gap-x-3">
        {review > 0 && (
          <span>{t(`${K}.banner.review`, { smart_count: review })}</span>
        )}
        {held > 0 && (
          <span>{t(`${K}.banner.held`, { smart_count: held })}</span>
        )}
      </AlertTitle>
      <AlertDescription className="text-foreground">
        <Link to={EMAIL_ATTENTION_PATH} className="font-medium underline">
          {t(`${K}.banner.link`)}
        </Link>
      </AlertDescription>
    </Alert>
  );
};
